import type { ProjectRepository } from '@zetyar/data-contracts'
import { createSupabaseProjectRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webProjectRepository: ProjectRepository = createSupabaseProjectRepository(getSupabaseClient())
